xplenty.directive('ngModel', function () {
  return {
    restrict: 'A',
    priority: -1, // give it lower priority than built-in ng-model
    link(scope, element, attr) {
      let hasEventBeenEmitted = false;
      scope.$watch(attr.ngModel, function (value) {
        if (value && !hasEventBeenEmitted) {
          element[0].dispatchEvent(
            new Event('input', {
              bubbles: true,
              cancelable: true,
            }),
          );
          hasEventBeenEmitted = true;
        }
      });
    },
  };
});
